<div class="modal-backdrop fade show" *ngIf="isVisible"></div>
<div class="modal fade show d-block" tabindex="-1" role="dialog" *ngIf="isVisible">
  <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Edit Generated Tests</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
      </div>
      <div class="modal-body">
        <p class="text-muted small" *ngIf="microScenarioIdForContext">
          Editing tests for Micro-Scenario: {{ microScenarioIdForContext }}
        </p>
        <table class="table table-sm table-hover edit-tests-modal-table">
          <thead>
            <tr>
              <th *ngFor="let col of columnsForModal" [hidden]="col.startsWith('_')"> {{ col === 'ID' ? '#' : (col | titlecase) }}
              </th>
              <th style="width: 120px;">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let test of editableModalTests; let i = index; let first = first; let last = last; trackBy: trackByModalTest" class="modal-test-row">
              <td *ngFor="let col of columnsForModal" [hidden]="col.startsWith('_')">
                <ng-container *ngIf="col === 'ID'">
                  <span>{{ i + 1 }}</span>
                </ng-container>
                <ng-container *ngIf="col !== 'ID' && !col.startsWith('_')">
                  <textarea class="form-control form-control-sm"
                            [(ngModel)]="test[col]"
                            rows="2"
                            placeholder="Enter {{col | titlecase}}"></textarea>
                </ng-container>
              </td>
              <td>
                <button type="button" class="btn btn-outline-secondary btn-sm me-1" (click)="moveTestUp(i)" [disabled]="first" title="Move Up">
                  <i class="fa fa-arrow-up"></i>
                </button>
                <button type="button" class="btn btn-outline-secondary btn-sm me-1" (click)="moveTestDown(i)" [disabled]="last" title="Move Down">
                  <i class="fa fa-arrow-down"></i>
                </button>
                <button type="button" class="btn btn-danger btn-sm" (click)="removeTest(i)" title="Remove this test">
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="onSave()">Save Changes</button>
      </div>
    </div>
  </div>
</div>
